'use strict';

class Transformer {
    construct() {
        this.format = 'Y-m-d H:i:s';
    }

    reverseTransform(value, model) {
        return value;
    }
}

window.AdFinanceFrontendBundleFormDataTransformerStringToDateTimeTransformer = Transformer;



// WEBPACK FOOTER //
// ./app/Resources/assets/js/lib/formTransformer/adfinance.stringToDateTime.js